<script setup lang="ts">
import { Primitive } from "reka-ui";
import type { BasePrimitiveProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends BasePrimitiveProps {
	absolute?: boolean;
	fixed?: boolean;
}

const props = defineProps<Props>();
</script>

<template>
	<Primitive
		:as="props.as"
		:asChild="props.asChild"
		:class="
			cn(
				{
					'z-10 bg-black/30 dark:bg-black/50': true,
					'absolute inset-0': props.absolute,
					'fixed inset-0': props.fixed,
				},
				props.class
			)
		"
	>
		<slot />
	</Primitive>
</template>
